<div class="col-sm-12 close-button" mat-dialog-title>
  <mat-icon (click)="onCancel()">close</mat-icon>
</div>
<mat-dialog-content>

  <mat-form-field *ngIf="!isLoading" appearance="fill" class="full-width">
    <mat-label>{{ (data.field === 'note' ? 'NOTES_ATTACHMENTS.NEW_NOTE' : 'DIALOGS.COMMENT_LABEL') | translate }}</mat-label>
    <textarea
      matInput
      maxlength="5000"
      [formControl]="commentFormControl"
      [placeholder]="data.field === 'note' ? ('NOTES_ATTACHMENTS.NOTE_PLACEHOLDER_TEXT' | translate) : ''"
    ></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onConfirm()" [disabled]="commentFormControl.invalid || isLoading || (data.field === 'note' && !commentFormControl.value?.trim())">
    {{ (data.field === 'note' ? 'NOTES_ATTACHMENTS.ADD_NOTE' : 'COMMON.BUTTONS.UPDATE') | translate }}
  </button>
  <button mat-raised-button class="discard-changes" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
